import { useStartScoringMutation } from '../api';

export const useStartScoring = () => {
  const [startScoring, { isLoading, isSuccess, isError }] = useStartScoringMutation();

  return { startScoring, isLoading, isError, isSuccess };
};
